import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const VISITOR_KEY = 'vt_visitor_id';
const VARIANT_KEY = 'vt_ab_variant';

const uuid = () => {
  // Lightweight UUID — no crypto dependency required
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getVisitorId = () => {
  let v = localStorage.getItem(VISITOR_KEY);
  if (!v) { v = uuid(); localStorage.setItem(VISITOR_KEY, v); }
  return v;
};

/**
 * Fires a tracking event for the A/B funnel. Safe to call from anywhere — never throws.
 */
export const trackAbEvent = async (event, opts = {}) => {
  try {
    await axios.post(`${API}/api/ab/track`, {
      visitor_id: getVisitorId(),
      event,
      value: opts.value,
      user_id: opts.user_id,
      meta: opts.meta || {},
    });
  } catch { /* silent — analytics must never break UX */ }
};

/**
 * useAbVariant — returns 'A' (lead-first) or 'B' (direct register).
 * - Reads cached variant from localStorage on mount for SSR-safe sync render.
 * - On first visit, calls /api/ab/assign which returns the deterministic split.
 */
export const useAbVariant = () => {
  const [variant, setVariant] = useState(() => localStorage.getItem(VARIANT_KEY) || null);

  useEffect(() => {
    if (variant) return;
    let alive = true;
    (async () => {
      try {
        const { data } = await axios.post(`${API}/api/ab/assign`, {
          visitor_id: getVisitorId(),
          landing_path: window.location.pathname + window.location.search,
          referrer: document.referrer || null,
          utm_source: new URLSearchParams(window.location.search).get('utm_source'),
          utm_campaign: new URLSearchParams(window.location.search).get('utm_campaign'),
        });
        if (alive && data?.variant) {
          localStorage.setItem(VARIANT_KEY, data.variant);
          setVariant(data.variant);
          // Auto-fire landing view event
          trackAbEvent('view_landing', { meta: { variant: data.variant } });
        }
      } catch { /* silent */ }
    })();
    return () => { alive = false; };
  }, [variant]);

  return variant;
};
